import styled from 'styled-components';

interface LimitModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  type: 'multiple' | 'subjective';
  multipleLimit: number;
  subjectiveLimit: number;
}

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;

const Modal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 450px;
  background: white;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  z-index: 1000;
`;

const ModalTitle = styled.h3`
  display: flex;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
   margin: -10px 0 10px 0; // 상단 마진 제거하고 하단 마진만 유지
`;

const ModalContent = styled.div`
//   font-size: 14px;
font-weight: 400;
  margin-bottom: 24px;
  line-height: 1.5;
  color: #666;
`;

const ModalButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

const CancelButton = styled.button`
  width: 150px;
  height: 45px;
  border-radius: 100px;
  border: 1px solid #C0C0C0;
  background: #C0C0C0;
  color: white;
  cursor: pointer;
`;

const ConfirmButton = styled.button`
  width: 150px;
  height: 45px;
  border-radius: 100px;
  border: none;
  background: #2282E9;
  color: white;
  cursor: pointer;
`;

const BlueText = styled.span`
  color: #2282E9;
`;

const SmallText = styled.div`
  font-size: 12px;
  color: #9F9F9F;
  margin-top: 24px;
`;

const HorizontalDivider = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid #e0e0e0; // 선 색상 설정
  margin: 0 0 60px 0; // 상단 마진 제거하고 하단 마진만 유지
`;



export default function LimitModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  type,
  multipleLimit,
  subjectiveLimit
}: LimitModalProps) {
  if (!isOpen) return null;

  const title = type === 'multiple' ? '객관식 질문 추가' : '주관식 질문 추가';

  return (
    <>
      <ModalOverlay onClick={onClose} />
      <Modal>
        <ModalTitle>{title}</ModalTitle>
        <HorizontalDivider />
        <ModalContent>
          무료로 제공되는<br />
          직접 질문 추가 문항 수는<br />
          <BlueText>객관식 {multipleLimit} 문항</BlueText> / <BlueText>주관식 {subjectiveLimit} 문항</BlueText> 입니다.<br /><br />
          현재 무료로 제공되는<br />
          질문 추가 수가 소진되어<br />
          새롭게 추가되는 질문 추가 요금이 발생됩니다.<br /><br />

          <SmallText>(추가 후 4단계 견적서를 통해 견적 확인하실 수 있습니다.)</SmallText>
          <br />
        </ModalContent>
        <ModalButtonContainer>
          <CancelButton onClick={onClose}>취소</CancelButton>
          <ConfirmButton onClick={onConfirm}>추가하기</ConfirmButton>
        </ModalButtonContainer>
      </Modal>
    </>
  );
} 